import React from 'react';
import { compose, withProps } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import PropTypes from 'prop-types';

const SearchWorkerMap = compose(
    withProps({
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `400px` }} />,
        mapElement: <div style={{ height: `100%` }} />,
    }),
    withGoogleMap
)((props) =>
    <GoogleMap
        defaultZoom={props.zoom ? props.zoom : 8}
        defaultCenter={{ lat: props.lat, lng: props.lng }}

    >
        {props.isMarkerShown && <Marker position={{ lat: props.lat, lng: props.lng }} onClick={props.onMarkerClick} />}
    </GoogleMap>
)

SearchWorkerMap.propTypes = {
    isMarkerShown: PropTypes.bool,
    onMarkerClick: PropTypes.func,
    lat: PropTypes.any,
    lng: PropTypes.any,
    zoom: PropTypes.number
}

SearchWorkerMap.defaultProps = {
    isMarkerShown: true
}

export default SearchWorkerMap;
